<template>
  <div>
    <modal id="confirmationModal" class="bulk-import-confirmation-modal" width="700px"   :value="showModal" effect="fade" @closed="closed"  large>
      <!-- custom header -->
      <div slot="modal-header" class="modal-header" >
        <h4 class="modal-title" style="">
          <strong>申請ルート（証書情報）</strong>
        </h4>
      </div>
      <div  class="modal-body bulk-import-confirmation-modal-body overflow-modal-body" :style="'height: '+model_height+'px;padding: 5px 15px; '">
        <table style="width:100%">
          <tr>
            <th style="width:5%"></th>
            <th style="width:15%"></th>
            <th style="width:33%">申請者</th>
            <th style="width:33%"></th>
            <th style="width:14%">状態</th>
          </tr>
          <tr>
            <td></td>
            <td>{{userDepartment}}</td>
            <td>{{userTeam}}</td>
            <td>{{ userShimei }}</td>
            <td>下書き</td>
          </tr>
          <tr>
            <td colspan="5"></td>
          </tr>
          <tr>
            <th></th>
            <th></th>
            <th>承認者</th>
            <th></th>
            <th>状態</th>
          </tr>
          <tr v-for="n in [1,2,3,4,5]" :key="n">
            <td>{{n}}.</td>
            <td>{{userDepartment}}</td>
            <td>
              <select  class="form-control select-box limited-height-box">
                  <option v-if="n > 1">（選択）</option>
                <option v-for="o in teamOptions" :key="o">{{o}}</option>
              </select>
            </td>
            <td>
              <select  class="form-control select-box limited-height-box">
                <option v-if="n > 1">（選択）</option>
                <option v-for="o in userOptions" :key="o">{{o}}</option>
              </select>
            </td>
            <td>承認待ち</td>
          </tr>
          <tr>
            <td colspan="5"></td>
          </tr>
          <tr>
            <td colspan="2">最終承認</td>
            <td colspan="2">ライセンス管理窓口（最終承認）</td>
            <td>承認待ち</td>
          </tr>
        </table>
        <br>
        <br>
        <br>
      </div>
      <div slot="modal-footer" class="modal-footer" style="background:white">
        <button type="button" style="width:120px;" :data-cy="'bulk-import-confirmation-modal-footer-yes-btn'" :class="'bulk-import-confirmation-modal-footer-yes-btn btn btn-primary '  " id="confirmationModalYes" @click="closed('yes')">申請</button>
        <button type="button" style="width:120px;" :class="'btn btn-default ' " @click="closed('no')">戻る</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue";
import { bus } from "@/libs/bus";
import { utils } from "@/libs/utils";
var vm = this;

import  modal  from "./local-modal";
Vue.component("modal", modal);

import debug from "debug";
var debug_msg = debug("esma:bulk-import-confirmation-modal");

export default {
  data() {
    return {
      show_modal: false,
      callback:null,
      model_height:"350",
      team_options:["tA","E","D","C"],
      user_options:["uA","E","D","C"],
      local_user_list:[]
    };
  },
  computed: {
    localUserList:{
      get(){
        return this.local_user_list;
      },
      set(v){
        this.userOptions = v.map(o => {return o.user_shimei;});
        this.teamOptions = v.map(o => {return o.team;});
        this.local_user_list = v;
      }
    },
    userDepartment() {
      return Vue.localStorage.get("userDepartment") || "";
    },
    userTeam() {
      return Vue.localStorage.get("userTeam") || "";
    },
    userShimei() {
      return Vue.localStorage.get("userShimei") || "";
    },
    userOptions:{
      get(){
        return this.user_options;
      },
      set(v){
        this.user_options = v;
      }
    },
    teamOptions:{
      get(){
        return this.team_options;
      },
      set(v){
        this.team_options = v;
      }
    },
    showModal() {
      return this.show_modal;
    }
  },
  methods: {
    showModalWindow(data) {
      this.show_modal = true;
      this.titleStyle = data.title_style || "";

      this.$ajax.post("/master_user/load_for_bulk_import/", {}, (err, data) => {
        this.localUserList = data;
      });
    },
    closed(mode) {
      if(typeof mode != "undefined"){
        console.log("mode",mode)
        this.show_modal = false;
        this.$emit('done',mode);
      }
    }
  },
  props: {
    tag: { type: String, default: "showBulkImportConfimationModal" }
  },
  mounted() {
    bus.$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
  }
};
</script>
<style scoped>
.overflow-modal-body {
  overflow-y: auto;
  border: solid 1px #d4d4d4;
}
th{
  background: #aba7a7;
  color: white;
  padding:2px 3px;
}
tr{
  height: 25px;
}
td{
  padding:4px 3px;
}
</style>



// WEBPACK FOOTER //
// certificate-information-connection-application-modal.vue?623d52cd